<template>
  <li
    v-editable="blok"
    :class="[spaceBetweenItems, computedFontStyle, computedTextColor]"
    :style="image?.filename ? { '--bullet-img-url': `url(${image.filename})` } : {}"
  >
    <BaseRichText :rich-text-template="blok.text" />
  </li>
</template>

<script lang="ts" setup>
import type { AssetStoryblok, SbListItemRichtextStoryblok, SbPluginInfermedicaFontPicker } from '@/types'

interface Props {
  blok: SbListItemRichtextStoryblok
  space: string
  font: SbPluginInfermedicaFontPicker | void
  image?: AssetStoryblok
}
const props = withDefaults(defineProps<Props>(), {
  space: '4',
})

const spaceBetweenItems = computed(() => `mb-${props.space}`)
const computedFontStyle = computed(() => props.font?.font.value ?? 'paragraph--m')
const computedTextColor = computed(() => props.font?.color_name ? `text-${props.font.color_name}` : '')
</script>
